import React, { Fragment, useCallback, useRef, useState } from "react";
import Popover, { PopoverHeader } from "@amzn/meridian/popover";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import Link from "@amzn/meridian/link";
import { FormattedMessage } from "react-intl";

/**
 * Show alert with a popover message
 */

const AlertWithPopover = (data) => {
  const alertInfo = data.data;
  const linkRef = useRef();
  const [open, setOpen] = useState(false);

  const onOpen = useCallback(() => setOpen(true), []);
  const onClose = useCallback(() => setOpen(false), []);
  return (
    <Fragment>
      <Link ref={linkRef} onClick={onOpen} type="secondary">
        <FormattedMessage
          id={alertInfo.id}
          defaultMessage={alertInfo.defaultMessage}
        />
      </Link>
      <Popover
        anchorNode={linkRef.current}
        open={open}
        onClose={onClose}
        position="top"
        alignment="right"
      >
        <PopoverHeader closeLabel="Close">
          <Text type="h100">{alertInfo.title}</Text>
        </PopoverHeader>
        <Column>
          <Text>{alertInfo.alertMessage}</Text>
        </Column>
      </Popover>
    </Fragment>
  );
};

export default AlertWithPopover;



// WEBPACK FOOTER //
// ./src/components/packageOverview/popover.js